import * as constants from "common/constants";

export const GITLAB_CLIENT_ID = import.meta.env.VITE_GITLAB_CLIENT_ID || constants.GITLAB_CLIENT_ID
export const GITLAB_REDIRECT_URL = import.meta.env.VITE_GITLAB_REDIRECT_URL || "http://localhost:5173/receive-access-code"
export const SERVER_WEBSOCKET_URL = import.meta.env.VITE_SERVER_WEBSOCKET_URL || `ws://${location.hostname}:8090`
export const GITLAB_BASE_URL = import.meta.env.VITE_GITLAB_BASE_URL || `https://gitlab.bot-dev.top`
